import Model from './Model'

export default class MaintenanceRecord extends Model {
  resource()
  {
    return 'maintenance-records'
  }
}
